import PropTypes from 'prop-types';
import React from 'react';
import { sanitiseText } from '../../helpers/sanitiseText';

const AdditionalContent = ({ content }) => {
  return (
    <div className="container additional-container">
      <div
        dangerouslySetInnerHTML={{
          __html: sanitiseText(content),
        }}
      />

      <style jsx>{`
        .additional-container {
          border-radius: 5px;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
          margin-bottom: 20px;
          padding: 20px;
          text-align: center;
        }

        @media (max-width: 575.98px) {
          .additional-container {
            background-position: 120% -20%;
          }
        }
      `}</style>
    </div>
  );
};

export default AdditionalContent;

AdditionalContent.propTypes = {
  content: PropTypes.string,
};
